import { render } from "./live.vue?vue&type=template&id=81fa23d4&scoped=true"
import script from "./live.vue?vue&type=script&lang=js"
export * from "./live.vue?vue&type=script&lang=js"

import "@/assets/css/new.scss?vue&type=style&index=0&lang=scss"
import "./live.vue?vue&type=style&index=1&id=81fa23d4&scoped=true&lang=css"
import "./live.vue?vue&type=style&index=2&id=81fa23d4&scoped=true&lang=scss"
import "./live.vue?vue&type=style&index=3&id=81fa23d4&lang=css"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81fa23d4"]])

export default __exports__